import { buildErrorMessage } from 'app/utils';
import { AxiosResponse } from 'axios';
import { IToken, IUserSchema } from 'generated/axios';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { useAuthApi } from './useAuthApi';
import useCookie from 'react-use-cookie';

export interface LoginRequest {
  username: string;
  password: string;
}
interface AuthenticationContextType extends IToken {
  login: (req: LoginRequest) => Promise<AxiosResponse<IToken, any>>;
  logout: () => Promise<AxiosResponse<object, any>>;
  updateTokens: (tokens: IToken) => void;
  removeTokens: () => void;
  loggedUser: IUserSchema | undefined;
  setLoggedUser: (user: IUserSchema) => void;
}

export const TOKENS = 'nvm_tkn';

const AuthenticationContext = createContext<AuthenticationContextType>({} as AuthenticationContextType);

export function AuthenticationProvider({ children }: { children: ReactNode }): JSX.Element {
  const [cookie, setCookie] = useCookie(
    TOKENS,
    JSON.stringify({ access_token: '', refresh_token: '', token_type: '' } as IToken),
  );

  const [loggedUser, setLogged] = useState<IUserSchema | undefined>();

  const setLoggedUser = (user: IUserSchema) => {
    setLogged(user);
  };

  const { authApi } = useAuthApi();

  const updateTokens = (token: IToken) => {
    setCookie(JSON.stringify(token));
  };

  const removeTokens = () => {
    setCookie(JSON.stringify({ access_token: '', refresh_token: '', token_type: '' } as IToken));
  };

  const login = async ({ username, password }: LoginRequest) => {
    console.log('faccio login');
    const resp = await authApi.getAccessToken(username, password);
    if (resp?.status === 200) {
      console.log('login OK => faccio update tokens');
      updateTokens(resp.data);
      return resp;
    } else {
      removeTokens();
      throw new Error(buildErrorMessage(resp));
    }
  };

  const logout = async () => {
    /*  const resp = await authApi.logoutUser(); */
    removeTokens();
    /* if (resp.status === 200) {
      return resp;
    } else {
      throw new Error(buildErrorMessage(resp));
    } */
  };

  const cachedValue: AuthenticationContextType = useMemo(
    () => ({
      login: login,
      logout: logout,
      ...JSON.parse(cookie),
      updateTokens: updateTokens,
      removeTokens: removeTokens,
      loggedUser: loggedUser,
      setLoggedUser: setLoggedUser,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cookie, loggedUser],
  );

  return <AuthenticationContext.Provider value={cachedValue}>{children}</AuthenticationContext.Provider>;
}

//hook per utilizzo webSocket
export const useAuth = () => useContext(AuthenticationContext);
